import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAddVehicleListingMutation } from "store/services/vehicleListingApi";
import VehicleListingForm from "./vehicleListingComponents/VehicleListingForm";

const VehicleListingCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "External Driver Record", path: "/app/crm/vehicle-listing/list" },
    { title: "New External Driver Record" },
  ];

  const [addVehicleListing, { isLoading }] = useAddVehicleListingMutation();

  const handleCreateVehicleListing = async (data) => {
    try {
      const { _id } = await addVehicleListing(data).unwrap();
      toast.success("External Driver Record successfully created!");
      navigate(`/app/crm/vehicle-listing/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create External Driver Record!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <VehicleListingForm
          isBusy={isLoading}
          onSubmit={handleCreateVehicleListing}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VehicleListingCreateScreen;